import { useEffect } from 'react';
import { useUsageStore, getUsagePercentage, getUsageColor, getTimeUntilReset } from '../stores/usage';

export default function UsageIndicator() {
  const { usage, isLoading, fetchUsage } = useUsageStore();

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  if (isLoading || !usage) {
    return (
      <div className="px-4 py-3 border-t border-line">
        <div className="animate-pulse">
          <div className="h-3 bg-ink-200 rounded w-24 mb-2"></div>
          <div className="h-2 bg-ink-200 rounded w-full mb-1"></div>
          <div className="h-2 bg-ink-200 rounded w-full"></div>
        </div>
      </div>
    );
  }

  // 사용량 제한이 비활성화된 경우
  if (!usage.isEnabled) {
    return (
      <div className="px-4 py-3 border-t border-line">
        <div className="text-xs text-ink-400">사용량 제한 없음</div>
      </div>
    );
  }

  const photoPercent = getUsagePercentage(usage.photoCount, usage.photoLimit);
  const inspectionPercent = getUsagePercentage(usage.inspectionCount, usage.inspectionLimit);
  const photoColorClass = getUsageColor(photoPercent);
  const inspectionColorClass = getUsageColor(inspectionPercent);

  const isPhotoExhausted = usage.photoCount >= usage.photoLimit;
  const isInspectionExhausted = usage.inspectionCount >= usage.inspectionLimit;
  const isAnyExhausted = isPhotoExhausted || isInspectionExhausted;

  const timeUntilReset = getTimeUntilReset(usage.nextResetAt);

  return (
    <div className="px-4 py-3 border-t border-line">
      {/* 헤더 */}
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-ink-500">오늘 사용량</span>
        <span className="text-xs text-ink-400">{timeUntilReset} 초기화</span>
      </div>

      {/* 사진 사용량 */}
      <div className="mb-2">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-ink-600">사진</span>
          <span className="text-xs text-ink-500">
            {usage.photoCount}/{usage.photoLimit}
          </span>
        </div>
        <div className="w-full bg-ink-200 rounded-full h-1.5">
          <div
            className={`${photoColorClass} h-1.5 rounded-full transition-all`}
            style={{ width: `${photoPercent}%` }}
          ></div>
        </div>
      </div>

      {/* 점검 사용량 */}
      <div className="mb-2">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-ink-600">점검</span>
          <span className="text-xs text-ink-500">
            {usage.inspectionCount}/{usage.inspectionLimit}
          </span>
        </div>
        <div className="w-full bg-ink-200 rounded-full h-1.5">
          <div
            className={`${inspectionColorClass} h-1.5 rounded-full transition-all`}
            style={{ width: `${inspectionPercent}%` }}
          ></div>
        </div>
      </div>

      {/* 소진 경고 */}
      {isAnyExhausted && (
        <div className="mt-2 p-2 bg-red-50 rounded-card-sm">
          <p className="text-xs text-red-700 font-medium">
            {isPhotoExhausted && isInspectionExhausted
              ? '사진/점검 일일 한도 소진'
              : isPhotoExhausted
                ? '사진 일일 한도 소진'
                : '점검 일일 한도 소진'}
          </p>
          <p className="text-xs text-red-600 mt-0.5">
            {timeUntilReset} 초기화됩니다
          </p>
        </div>
      )}
    </div>
  );
}
